import { IStatusPill } from 'types/ui/statusPill.interface'
import { IOpsSegmentContext, OpsLossBucket } from 'types/opsAnalytics.interface'

export const classifyLossBucket = (ctx: IOpsSegmentContext): OpsLossBucket => {
  if (ctx.zoneOnHold) return 'WEATHER_BLAST_HOLD'
  if (ctx.blockedByRequest) return 'BLOCKED_CROSS_DEPT'
  if (ctx.taskIsRepair && ctx.maintIsPlanned) return 'PLANNED_MAINT'
  if (ctx.taskIsRepair) return 'BREAKDOWN'
  if (ctx.outOfFuel) return 'NO_FUEL'
  if (!ctx.operatorPresent) return 'NO_OPERATOR'
  if (!ctx.hasTask) return 'NO_TASK'
  return 'PRODUCTIVE'
}

export const LOSS_BUCKET_META: {
  [k in OpsLossBucket]: { label: string; tone: IStatusPill['status']; definition: string }
} = {
  PRODUCTIVE: {
    label: 'Productive',
    tone: 'success',
    definition: 'Machine was manned, tasked and turning dirt — the time we get paid for.',
  },
  BREAKDOWN: {
    label: 'Breakdown',
    tone: 'danger',
    definition: 'Machine went down unplanned and a repair crew had to be pulled onto it.',
  },
  'PLANNED_MAINT': {
    label: 'Planned maintenance',
    tone: 'info',
    definition: 'Machine was booked into the workshop for a scheduled service — no surprise, no scramble.',
  },
  'NO_FUEL': {
    label: 'No fuel',
    tone: 'danger',
    definition: 'Machine and operator were ready, but the machine was out of fuel or waiting at the bowser.',
  },
  'NO_OPERATOR': {
    label: 'No operator',
    tone: 'warning',
    definition: 'Machine was ready to work but nobody qualified was in the seat.',
  },
  'NO_TASK': {
    label: 'No task',
    tone: 'warning',
    definition: 'Machine was ready with an operator, but the scheduler had no work queued for it.',
  },
  'BLOCKED_CROSS_DEPT': {
    label: 'Blocked cross-dept',
    tone: 'accent',
    definition: 'Work stood still waiting on another department to answer a request.',
  },
  'WEATHER_BLAST_HOLD': {
    label: 'Weather / blast hold',
    tone: 'neutral',
    definition: 'Zone was on hold for a blast window or a weather call — nobody moves until the all-clear.',
  },
}
